// src/pages/Dashboard.jsx
import React from 'react';

const Dashboard = () => {
  return (
    <div className="p-8 mt-16 min-h-screen bg-gray-50"> {/* mt-16 for fixed header, light background */}
      {/* Text Container - Welcome / Announcement Section */}
      <div className="mb-12 text-center">
        <div className=" rounded-2xl shadow-lg border border-gray-200 p-10 mx-auto">
          <h1 className="text-xl md:text-5xl font-extrabold mb-4">
            Welcome to Your Dashboard
          </h1>
        
        </div>
      </div>

      {/* Stats Cards Grid */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">کل پروجیکٹس</h3>
          <p className="text-5xl font-extrabold text-indigo-600">24</p>
          <p className="text-sm text-gray-500 mt-2">Total Projects</p>
,        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">جاری پروجیکٹس</h3>
          <p className="text-5xl font-extrabold text-yellow-600">8</p>
          <p className="text-sm text-gray-500 mt-2">In Progress</p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">مکمل شدہ</h3>
          <p className="text-5xl font-extrabold text-green-600">16</p>
          <p className="text-sm text-gray-500 mt-2">Completed</p>
        </div>
      </div> */}

      {/* Recent Activity Section */}
      {/* <div className="mt-12">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">تازہ سرگرمیاں</h2>
        <div className="bg-white rounded-2xl shadow-xl p-10 border border-gray-200">
          <p className="text-gray-700 text-lg leading-relaxed text-center">
            آپ کے حالیہ پروجیکٹس، ترامیم، اور اپ ڈیٹس یہاں ظاہر ہوں گے۔<br />
            Your recent projects, edits, and updates will appear here soon...
          </p>
          <div className="mt-8 flex justify-center">
            <div className="bg-gray-200 border-2 border-dashed rounded-xl w-32 h-32" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;